// All available LocalStorage keys
export enum E_LsKeys {
  EraToken = 'ERA_TOKEN',
  EraRefreshToken = 'ERA_REFRESH_TOKEN',
  EraLogoutSync = 'ERA_LOGOUT_SYNC',
  EraPwaPromptDismissed = 'ERA_PWA_PROMPT_DISMISSED',
  EraPwaUpdateAvailable = 'ERA_PWA_UPDATE_AVAILABLE',
  EraCertificatesRest = 'ERA_CERTIFICATES_REST',
  EraTutorialHomeStatus = 'ERA_TUTORIAL_HOME_STATUS',
  EraBecomeShareholderPendingUserId = 'ERA_BECOME_SHAREHOLDER_PENDING_USER_ID',
}
